export const BeforeOrderFormFields = {
  readRequirements: {
    id: 'field--before-order-read-and-understand-requirements',
    required: true,
    excludeFromPayload: true,
    rules: ['required'],
    value: 'I have read and understand requirements.',
  },
};
